var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"rules":_vm.rules,"outlined":"","suffix":_vm.suffix,"prefix":_vm.prefix,"label":_vm.label},model:{value:(_vm.maskedValue),callback:function ($$v) {_vm.maskedValue=$$v},expression:"maskedValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }